export default {
    TEXT: "text",
    LIBRARYNUMBER: "library number",
    TYPE: "library type",
    IMAGE: "image",
    LIBRARYTYPE: "library type",
    NUMBEROFPINS: "number of pins",
    NUMBEROFMECHPINS: "number of mech pins",
    PLACEBOUNDWIDTH: "placebound width",
    PLACEBOUNDHEIGHT: "placebound height",
    FILES: "files"
}


// WEBPACK FOOTER //
// ./src/constants/LibraryPropertiesType.js